import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=1880c71a&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Project.vue?vue&type=style&index=1&id=1880c71a&lang=scss&scoped=true&"
import style2 from "./Project.vue?vue&type=style&index=2&id=1880c71a&scoped=true&lang=css&"
import style3 from "./Project.vue?vue&type=style&index=3&id=1880c71a&scoped=true&lang=css&"
import style4 from "./Project.vue?vue&type=style&index=4&id=1880c71a&scoped=true&lang=css&"
import style5 from "./Project.vue?vue&type=style&index=5&id=1880c71a&scoped=true&lang=css&"
import style6 from "./Project.vue?vue&type=style&index=6&id=1880c71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880c71a",
  null
  
)

export default component.exports